import { StAuthService } from '@stilingue/st-auth-service';
import { featureFlagFlags } from '@/plugins/rollout';
import { isProdVersion } from '@stilingue/st-environment-controller-utils';
import { injectSessionIdHeader } from './session-headers';
import gateway from './Gateway';

const version = isProdVersion()
  ? featureFlagFlags.AuthServiceVersionProd.getValue()
  : featureFlagFlags.AuthServiceVersionStaging.getValue();
const afterParser = response => response.data;
const MAX_EMAILS_PER_REQUEST = 100;

class AuthService extends StAuthService {
  constructor(apiGateway, apiVersion) {
    super(apiGateway, apiVersion);
    this.api = injectSessionIdHeader(this.api);
  }

  async getUsersByEmails(emails) {
    const users = [];
    let notFound = 0;

    for (let index = 0; index < emails.length; index += MAX_EMAILS_PER_REQUEST) {
      const batch = emails.slice(index, index + MAX_EMAILS_PER_REQUEST);
      const result = await this.api.post(
        { url: 'v2/users/get-by-emails', emails: batch },
      ).then(afterParser);

      if (!result || !Array.isArray(result.users) || typeof result.notFound !== 'number') {
        throw new Error('Resposta inválida ao buscar usuários pelo e-mail.');
      }

      users.push(...result.users);
      notFound += result.notFound;
    }

    return { users, notFound };
  }
}

export default new AuthService(gateway, version);
